export default __webpack_public_path__ + "static/media/book_yellow.02a004b6.svg";